
const zh_CN_shell = {
    "appAccess.serviceUnavailableTitle": "服务当前不可用",
    "appAccess.serviceUnavailableDescription": "该服务当前不可用，因为此商户尚未启用一个或多个依赖服务。",
    "appAccess.serviceUnavailableDependencies": "如需开通，请联系销售启用：{services}。",
    "appAccess.accessDeniedTitle": "无访问权限",
    "appAccess.accessDeniedDescription": "你当前的角色没有权限访问此页面。",
    "appAccess.accessDeniedDetail": "如需访问此服务，请联系你的管理员。",
    "appAccess.appUnavailableEyebrow": "应用不可用",
    "appAccess.appNotFoundTitle": "未找到应用",
    "appAccess.appNotFoundDescription": "当前 shell 目录中不存在所选应用。",
    "appAccess.goToApp": "进入应用",
    "appAccess.backToDashboard": "返回仪表板",
    "appAccess.accessDeniedEyebrow": "无访问权限",
    "appAccess.unavailableAppEyebrow": "应用不可用",
    "appAccess.noDescription": "当前条目暂无应用说明。",
    "appAccess.permissionDeniedNote": "该服务已为商户启用，但你当前的角色无权访问。",
    "appAccess.dependencyMissingNote": "该服务依赖以下服务：{services}。如需启用所需服务，请联系销售。",
    "appAccess.unavailableNote": "此应用可用于发现，但当前商户工作区暂未开放。",
    "appAccess.viewDocs": "查看文档",
    "appAccess.contactSales": "联系销售",
    "form.back": "返回"
}

export {
    zh_CN_shell
}
